<template>
  <router-view></router-view>
</template>

<style lang="scss">
@font-face {
  font-family: "Gilory";
  src: local("Gilory"), url(./fonts/Gilroy-Medium.ttf) format("truetype");
}
body {
  font-family: "Gilory", Helvetica, Arial !important;
}

// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-grid.min.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-material.min.css";
// Main demo style scss
@import "assets/sass/style.vue";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
// @import "assets/sass/style.vue.rtl";
</style>

<script>
import Vue from 'vue';
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
Vue.prototype.$eventBus = new Vue();
export default {
  name: "MetronicVue",
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  },
};
</script>
